/** Loads a bigger font stack to include accent letters
 *  https://wix.atlassian.net/browse/NWB-12465
 *  https://wix.atlassian.net/browse/NWB-12560
 *
 */
export const patchFontNameForAccentLetters = (font) => {
    if (font?.includes('brandon-grot-w01-light')) {
        return font?.replace('brandon-grot-w01-light', 'brandon-grot-w01-light,brandon-grot-w05-light');
    }
    if (font?.includes('avenir-lt-w01_35-light1475496')) {
        return font?.replace('avenir-lt-w01_35-light1475496', 'avenir-lt-w01_35-light1475496,avenir-lt-w01_35-light');
    }
    return font;
};
//# sourceMappingURL=patchFontNameForAccentLetters.js.map